import * as actionTypes from "./actionTypes";

const initialState = {
  loading: false,
  data: {}
};

const fetchWarrantyStart = (state) => ({
  ...state,
  loading: true
});

const fetchWarrantySuccess = (state, action) => ({
  ...state,
  loading: false,
  data: action.data
});

const fetchWarrantyFail = (state) => ({
  ...state,
  loading: false
});

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_WARRANTY_TABLE_START:
      return fetchWarrantyStart(state);
    case actionTypes.FETCH_WARRANTY_TABLE_SUCCESS:
      return fetchWarrantySuccess(state, action);
    case actionTypes.FETCH_WARRANTY_TABLE_FAIL:
      return fetchWarrantyFail(state);
    default:
      return state;
  }
};

export default reducer;
